// src/pages/FilesManager/components/Tabs.jsx
import React from 'react';

const Tabs = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { key: 'all', label: 'All Folders' },
    { key: 'personal', label: 'Personal Folders' },
    { key: 'customer', label: 'Customer Folders' },
  ];

  return (
    <div className="flex space-x-4 border-b pb-2">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`px-4 py-2 ${
            activeTab === tab.key
              ? 'border-b-2 border-blue-500 text-blue-500'
              : 'text-gray-500'
          }`}
          onClick={() => setActiveTab(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
